// src/authManager.js
let user;

export const setUser = (newUser) => {
  user = newUser;
};

export const getUser = () => {
  return user;
};
